import { createBrowserRouter } from "react-router";
import { RootLayout } from "@/routes/layouts/RootLayout";
import { PublicLayout } from "@/routes/layouts/PublicLayout";
import { DashboardLayout } from "@/routes/layouts/DashboardLayout";
import { PrayLayout } from "@/routes/layouts/PrayLayout";
// Temporarily hidden — restore when Live Display returns
// import { LiveDisplayLayout } from "@/routes/layouts/LiveDisplayLayout";
import { RouteErrorFallback } from "@/routes/layouts/RouteErrorFallback";
import { NotFoundPage } from "@/routes/layouts/NotFoundPage";

import PublicHome from "@/routes/(public)/page";
import LoginPage from "@/routes/(public)/login/page";
import AcceptInvitePage from "@/routes/(public)/accept-invite/page";
import TrainingSignupPage from "@/routes/(public)/training-signup/page";
import ViewResponsePage from "@/routes/(public)/view-response/page";
import UnauthorizedPage from "@/routes/(public)/unauthorized/page";

import AdminPage from "@/routes/(dashboard)/admin/page";
import AdminSettingsPage from "@/routes/(dashboard)/admin/settings/page";
import AdminArchivePage from "@/routes/(dashboard)/admin/archive/page";
import AdminUsersPage from "@/routes/(dashboard)/admin/users/page";
import ModeratorPage from "@/routes/(dashboard)/moderator/page";
import ModeratorPrayersPage from "@/routes/(dashboard)/moderator/prayers/page";
import ProducerPage from "@/routes/(dashboard)/producer/page";
import MyPrayersPage from "@/routes/(dashboard)/my-prayers/page";
import SubmissionsPage from "@/routes/(dashboard)/submissions/page";
import StagePage from "@/routes/(dashboard)/stage/page";
import PrayerPartnerPage from "@/routes/(dashboard)/prayer-partner/page";

import PrayPage from "@/routes/pray/page";
import SubmitPage from "@/routes/submit/page";
// Temporarily hidden — restore when Live Display returns
// import LiveDisplayPage from "@/routes/live-display/page";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    errorElement: <RouteErrorFallback />,
    children: [
      {
        element: <PublicLayout />,
        errorElement: <RouteErrorFallback />,
        children: [
          { index: true, element: <PublicHome /> },
          { path: "login", element: <LoginPage /> },
          { path: "accept-invite", element: <AcceptInvitePage /> },
          { path: "training-signup", element: <TrainingSignupPage /> },
          { path: "view-response", element: <ViewResponsePage /> },
          { path: "unauthorized", element: <UnauthorizedPage /> },
        ],
      },
      {
        path: "pray",
        element: <PrayLayout />,
        errorElement: <RouteErrorFallback />,
        children: [{ index: true, element: <PrayPage /> }],
      },
      {
        path: "submit",
        element: <SubmitPage />,
        errorElement: <RouteErrorFallback />,
      },
      // Temporarily hidden — restore when Live Display returns
      // {
      //   path: "live-display",
      //   element: <LiveDisplayLayout />,
      //   errorElement: <RouteErrorFallback />,
      //   children: [{ index: true, element: <LiveDisplayPage /> }],
      // },
      {
        path: "admin",
        element: <DashboardLayout />,
        errorElement: <RouteErrorFallback />,
        children: [
          { index: true, element: <AdminPage /> },
          { path: "settings", element: <AdminSettingsPage /> },
          { path: "archive", element: <AdminArchivePage /> },
          { path: "users", element: <AdminUsersPage /> },
        ],
      },
      {
        path: "moderator",
        element: <DashboardLayout />,
        errorElement: <RouteErrorFallback />,
        children: [
          { index: true, element: <ModeratorPage /> },
          { path: "prayers", element: <ModeratorPrayersPage /> },
        ],
      },
      {
        path: "producer",
        element: <DashboardLayout />,
        errorElement: <RouteErrorFallback />,
        children: [{ index: true, element: <ProducerPage /> }],
      },
      {
        path: "my-prayers",
        element: <DashboardLayout />,
        errorElement: <RouteErrorFallback />,
        children: [{ index: true, element: <MyPrayersPage /> }],
      },
      {
        path: "submissions",
        element: <DashboardLayout />,
        errorElement: <RouteErrorFallback />,
        children: [{ index: true, element: <SubmissionsPage /> }],
      },
      {
        path: "stage",
        element: <DashboardLayout />,
        errorElement: <RouteErrorFallback />,
        children: [{ index: true, element: <StagePage /> }],
      },
      {
        path: "prayer-partner",
        element: <DashboardLayout />,
        errorElement: <RouteErrorFallback />,
        children: [{ index: true, element: <PrayerPartnerPage /> }],
      },
      { path: "*", element: <NotFoundPage /> },
    ],
  },
]);
